export const CONFLUENCE_GENERATOR_ID = 'https://www.atlassian.com/#Confluence';

export const JIRA_GENERATOR_ID = 'https://www.atlassian.com/#Jira';
// To support icons for all Jira task types.
export const JIRA_TASK = 'JiraTask';
export const JIRA_SUB_TASK = 'JiraSubTask';
export const JIRA_STORY = 'JiraStory';
export const JIRA_BUG = 'JiraBug';
export const JIRA_EPIC = 'JiraEpic';
export const JIRA_INCIDENT = 'JiraIncident';
export const JIRA_SERVICE_REQUEST = 'JiraServiceRequest';
export const JIRA_CHANGE = 'JiraChange';
export const JIRA_PROBLEM = 'JiraProblem';
export const JIRA_CUSTOM_TASK_TYPE = 'JiraCustomTaskType';

//List of provider keys that support theme modes for the embedded content.
export const PROVIDER_KEYS_WITH_THEMING = [
	'jira-object-provider',
	'confluence-object-provider',
	'watermelon-object-provider',
	'legion-object-provider',
	'avpviz-object-provider',
];
